gsap.registerPlugin(ScrollTrigger);


$(function() {
    $(".other-menus-slides").slick({
        autoplay: true,
        centerMode: true,
        centerPadding: "10%",
        slidesToShow: 4,
        initialSlide: 1,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 1, //画面幅750px以下でスライド3枚表示
            }
        }]
    });


    function debounce(func, wait) {
        let timeout;

        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };

            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    };

    let lastWidth = window.innerWidth;

    function handleResize() {
        const currentWidth = window.innerWidth;
        if (currentWidth !== lastWidth) {
            $(".other-menus-slides").slick('slickGoTo', 1, 0);
            lastWidth = currentWidth;
        }
    }

    const debouncedHandleResize = debounce(handleResize, 1500);
    window.addEventListener('resize', debouncedHandleResize);




});

$(function() {
    $(".nutrition-slider").slick({
        dots: true,
        arrows: true,
        prevArrow: '<button class="slide-arrow prev-arrow"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"></button>'
    });
});

$(function() {
  $('.grand-menu-add-slider').slick({
    autoplay: true,
    dots: true,
    pauseOnHover: false,
  });
});

$(function() {
    function sliderSetting() {

        var width = $(window).width();

        if (width <= 1199) {
            $(".customer-voices-slider").not('.slick-initialized').slick({
                autoplay: true,
                adaptiveHeight: true,
                centerMode: true,
                centerPadding: "10%",
            });
        } else {
            $('.customer-voices-slider.slick-initialized').slick('unslick');
        }
    }

    sliderSetting();

    $(window).resize(function() {
        sliderSetting();
    });
});



$(function() {
    $('.accordion-header').click(function() {
        $(this).next('.accordion-inner').slideToggle();
        $(this).toggleClass("open");
    });
});

$(function() {
    gsap.utils.toArray(".future-menu-nutrients1").forEach(target => {
        gsap.set(target, {
            x: 100,
            y: 70,
            opacity: 0,
            scale: 0.5
        });
        gsap.to(target, {
            x: 0,
            y: 0,
            opacity: 1,
            scale: 1,
            scrollTrigger: {
                trigger: target,
                start: 'top bottom',
                end: 'bottom 60%',
                toggleActions: 'play none none reverse',
                // markers:true,
                scrub: true,
            }
        });
    });
    gsap.utils.toArray(".future-menu-nutrients2").forEach(target => {
        gsap.set(target, {
            x: -100,
            y: 70,
            opacity: 0,
            scale: 0.5
        });
        gsap.to(target, {
            x: 0,
            y: 0,
            opacity: 1,
            scale: 1,
            scrollTrigger: {
                trigger: target,
                start: 'top bottom',
                end: 'bottom 60%',
                toggleActions: 'play none none reverse',
                // markers:true,
                scrub: true,
            }
        });
    });
    gsap.utils.toArray(".future-menu-nutrients3").forEach(target => {
        gsap.set(target, {
            x: 100,
            y: 0,
            opacity: 0,
            scale: 0.5
        });
        gsap.to(target, {
            x: 0,
            y: 0,
            opacity: 1,
            scale: 1,
            scrollTrigger: {
                trigger: target,
                start: 'top bottom',
                end: 'bottom 60%',
                toggleActions: 'play none none reverse',
                // markers:true,
                scrub: true,
            }
        });
    });
    gsap.utils.toArray(".future-menu-nutrients4").forEach(target => {
        gsap.set(target, {
            x: -100,
            y: 0,
            opacity: 0,
            scale: 0.5
        });
        gsap.to(target, {
            x: 0,
            y: 0,
            opacity: 1,
            scale: 1,
            scrollTrigger: {
                trigger: target,
                start: 'top bottom',
                end: 'bottom 60%',
                toggleActions: 'play none none reverse',
                // markers:true,
                scrub: true,
            }
        });
    });
    gsap.utils.toArray(".future-menu-nutrients5").forEach(target => {
        gsap.set(target, {
            x: 100,
            y: -70,
            opacity: 0,
            scale: 0.5
        });
        gsap.to(target, {
            x: 0,
            y: 0,
            opacity: 1,
            scale: 1,
            scrollTrigger: {
                trigger: target,
                start: 'top bottom',
                end: 'bottom 60%',
                toggleActions: 'play none none reverse',
                // markers:true,
                scrub: true,
            }
        });
    });
    gsap.utils.toArray(".future-menu-nutrients-point").forEach(target => {
        gsap.set(target, {
            opacity: 0,
            scale: 0.2
        });
        gsap.to(target, {
            x: 0,
            y: 0,
            opacity: 1,
            scale: 1,
            scrollTrigger: {
                trigger: target,
                start: 'top bottom',
                end: 'bottom 60%',
                toggleActions: 'play none none reverse',
                // markers:true,
                scrub: true,
            }
        });
    });

    gsap.utils.toArray(".fade-zoom").forEach(target => {
        gsap.set(target, {
            opacity: 0,
            scale: 0.5,
        });
        gsap.to(target, {
            opacity: 1,
            scale: 1,
            scrollTrigger: {
                trigger: target,
                start: 'top bottom',
                end: 'bottom 60%',
                toggleActions: 'play none none reverse',
                // markers:true,
                scrub: true,
            },
        });
    });

    gsap.utils.toArray(".fade-in").forEach(target => {
        gsap.set(target, {
            opacity: 0,
            y: 30,
            scale: 0.9
        });
        gsap.to(target, {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 1.5,
            scrollTrigger: {
                trigger: target,
                start: 'top bottom',
                end: 'bottom 40%',
                toggleActions: 'play none none reverse',
                // markers:true,
                // scrub:true,
            },

        });
    });
    gsap.utils.toArray(".fade-in-arrow").forEach(target => {
        gsap.set(target, {
            opacity: 0,
            y: -30,
            scale: 0.9
        });
        gsap.to(target, {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 1.5,
            scrollTrigger: {
                trigger: target,
                start: 'top bottom',
                end: 'bottom 40%',
                toggleActions: 'play none none reverse',
                // markers:true,
                // scrub:true,
            },

        });
    });
    gsap.utils.toArray(".fade-in2").forEach(target => {
        gsap.set(target, {
            opacity: 0
        });
        gsap.to(target, {
            opacity: 1,
            duration: 2,
            scrollTrigger: {
                trigger: target,
                start: 'top bottom',
                end: 'bottom 40%',
                toggleActions: 'play none none reverse',
                // markers:true,
                // scrub:true,
            },

        });
    });
    gsap.utils.toArray(".fade-in-delay").forEach(target => {
        gsap.set(target, {
            opacity: 0,
            y: 30,
            scale: 0.8
        });
        gsap.to(target, {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 1.5,
            delay: 0.5,
            scrollTrigger: {
                trigger: target,
                start: 'top bottom',
                end: 'bottom 40%',
                toggleActions: 'play none none reverse',
                // markers:true,
                // scrub:true,
            },

        });
    });


});


document.addEventListener('DOMContentLoaded', function() {

    setInterval(function() {
        checkCvButtonsInView();
        checkPosition();
    }, 200);

});




const fixBtnFlag = document.querySelector('.fixbtn__flag');
const cvButtons = document.querySelectorAll('.cv-btn');
const body = document.body;

function checkCvButtonsInView() {
    let isInView = false;

    cvButtons.forEach(btn => {
        const rect = btn.getBoundingClientRect();
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
            isInView = true;
        }
    });

    if (isInView) {
        body.classList.add('cv-in');
    } else {
        body.classList.remove('cv-in');
    }
}

function checkPosition() {
    const fixBtnFlagTop = fixBtnFlag.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;
    const middleOfScreen = windowHeight / 2;

    if (fixBtnFlagTop < middleOfScreen) {
        body.classList.add('fixbtn__on');
    } else {
        body.classList.remove('fixbtn__on');
    }
}